import { jsx as a } from "react/jsx-runtime";
import { Carousel as r } from "@nextgen-web-framework/all";
import { H as l, s } from "../../HeroComponentItem-d24cf99e.mjs";
const c = (e) => {
  var i, n;
  if (((i = e == null ? void 0 : e.images) == null ? void 0 : i.length) === 1) {
    const [t] = e.images;
    return /* @__PURE__ */ a(l, { ...t });
  }
  return /* @__PURE__ */ a("div", { className: s["hero-banner-carousel-container"], children: /* @__PURE__ */ a(r, { hideButtons: !1, id: "Hero-Banner-Carousel", isTileCarousel: !1, children: (n = e == null ? void 0 : e.images) == null ? void 0 : n.map((t) => /* @__PURE__ */ a(l, { ...t }, `${t.title}${t.subTitle}`)) }) });
};
export {
  c as default
};
//# sourceMappingURL=HeroBanner.js.map
